// extracted by mini-css-extract-plugin
export default {"rootFields":"styles_rootFields__108ns","switchBoxes":"styles_switchBoxes__dcw2U"};